<template>
    <v-container class="ort-saved px-6 pt-0 pb-3">
    <v-row class="ort-saved__content ma-0 pa-0">
        <v-dialog v-model="dialogCreate" width="2000">
            <ORTCreate 
                :parent_id="curr_folder_id"
                v-on:close="dialogCreate = false"
                v-on:report_published="report_published"
            ></ORTCreate>
        </v-dialog>
        <v-dialog v-model="dialogEdit" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="dialogTitle">Edit Report Name</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="editReportPayload.report_name" label="Report Name" outlined>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-row class="ma-0 pa-0">
                      <v-spacer></v-spacer>
                      <v-col cols="auto">
                        <v-btn class="actionText" outlined color="black" @click="dialogEdit = false;">Cancel</v-btn>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn class="actionText" outlined color="black" @click="edit_name_confirm()">Save Changes</v-btn>
                      </v-col>
                    </v-row>                
                  </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteConfirm">
            <v-card>
                <v-card-title>
                    <span class="dialogTitle">Are you Sure you Want to Delete - {{ deleteReportPayload.report_name }}?</span>
                </v-card-title>
                <v-card-actions>
                    <v-row class="ma-0 pa-0">
                      <v-spacer></v-spacer>
                      <v-col cols="auto">
                        <v-btn class="actionText" outlined color="black" @click="deleteConfirm = false;">Cancel</v-btn>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn class="actionText" outlined color="black" @click="delete_ort_report(deleteReportPayload.report_id)">Delete Report</v-btn>
                      </v-col>
                    </v-row>                
                  </v-card-actions>
            </v-card>
        </v-dialog>
        <v-col
            class="ort-saved__panel ma-0 pa-0"
            cols="12"
            v-if="page_loading && ort_reports.length === 0"
        >
            <v-row
                class="ort-saved__loading-row ma-0 pa-0"
                align="center"
                justify="center"
            >
                <v-col cols="auto">
                    <v-progress-circular
                        color="black"
                        size="100"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </v-col>
        <v-col class="ort-saved__panel ma-0 pa-0" cols="12" v-else-if="selected_page == 'ort_saved'">
            <EntityDirectory 
                entity_name="ORT report"
                :available_create_options="['create_folder', 'create_file']"
                :directory_data="ort_reports"
                :loading="directory_loading"
                :item_subcontent_config="item_subcontent_config"
                v-on:open_entity="open_report"
                v-on:edit_entity_name="update_report"
                v-on:delete_entity="delete_ort_report"
                v-on:move_files="move_reports"
                v-on:create_entity_folder="create_report_folder"
                v-on:create_entity="create_report_selected"
                v-on:reset_directory="get_ort_reports"
            ></EntityDirectory>
        </v-col>
    </v-row>
    </v-container>
</template>
  
<script>
  import ort_reporting_api_caller from "@/javascript/ort_reporting.js";
  import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS, ALERT_GENERIC_MESSAGE, ORT_REPORT_NAME_UPDATED } from "@/constants/constants";
  import EntityDirectory from "@/components/Utility/EntityDirectory.vue";
  import ORTCreate from "@/components/ORT/ORTPages/ORTComponents/ORTCreate.vue";

  export default {
    name: "ORTSaved",
    props: ["project_id", "data_version", "data_levels", "project_date_range", "reset", "project_filters"],
    components: {
        EntityDirectory,
        ORTCreate
    },
    data: () => ({
        client_id: '0000',
        selected_page: 'ort_saved',
        page_loading: true,
        saved_report_loading: true,
        item_subcontent_config: [
            { key: "status", label: "Status" },
            { key: "updated_time", label: "Last Update" },
        ],
        new_plan_loading: false,
        dialogEdit: false,
        dialogCreate: false,
        deleteConfirm: false,
        editReportPayload: {},
        deleteReportPayload: {},
        new_report_name: "",
        ort_reports: [],
        curr_folder_id: null,
        message_queue_payload: "rabbitmq publish test",

        report_start_date: '2023-11-01',
        report_end_date: '2023-11-05',

        report_min_start_date: '2023-11-01',
        report_max_end_date: '2025-12-30',

        report_name_rules: [
            value => !!value || 'Required.',
        ],


        available_campaigns: [],
        selected_campaigns: [],

        available_channels: [],
        selected_channels: [],

        available_partners: [],
        selected_partners: [],

        available_formats: [],
        selected_formats: [],

        available_audiences: [],
        selected_audiences: [],
        
        available_regions: [],
        selected_regions: [],

        loading_new_filters: true,
        
        available_pivot_variables: ['Campaign', 'Channel', 'Partner', 'Format'],
        selected_pivot_variables: ['Campaign', 'Channel', 'Partner', 'Format']
    }),


    async mounted(){
        await this.get_ort_reports();
        
        this.page_loading = false;
    },
    watch: {
    },
    computed: {
        create_enabled: function() {
            return this.new_report_name && this.report_start_date && this.report_end_date;
        },
        directory_loading() {
            return this.saved_report_loading;
        },
    },
    methods: {
        update_report_date: function(date) {
            this.report_start_date = date.length > 0 ? date[0] : ""
            this.report_end_date = date.length > 1 ? date[1] : ""
            this.get_filter_values()
        },
        get_filter_values: async function () {
            this.loading_new_filters = true;

            let payload = {
                project_id: this.$project.get_val(),
                report_start_date: this.report_start_date,
                report_end_date: this.report_end_date,
            };

            let token = await this.$auth.getTokenSilently();
            
            let result = await ort_reporting_api_caller.get_filters(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            if (result) {
                this.available_campaigns = result['campaign_names'];
                this.available_channels = result['channels'];
                this.available_partners = result['partners'];
                this.available_formats = result['formats'];
                this.available_audiences = result['audiences'];
                this.available_regions = result['regions'];
            }else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
            this.loading_new_filters = false;
        },
        get_ort_reports: async function () {
            this.saved_report_loading = true;
            this.loading_new_filters = true;

            let payload = {
                project_id: this.$project.get_val(),
            };

            let token = await this.$auth.getTokenSilently();
            
            let result = await ort_reporting_api_caller.get_reports(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            if (result && result["ort_reports"]) {
                this.ort_reports = result["ort_reports"];
                this.report_min_start_date = result["min_date"];
                this.report_max_end_date = result["max_date"];
                this.report_start_date = result["min_date"];
                this.report_end_date = result["max_date"];

                this.available_campaigns = result['campaign_names'];
                this.selected_campaigns = result['campaign_names'];

                this.available_channels = result['channels'];
                this.selected_channels = result['channels'];

                this.available_partners = result['partners'];
                this.selected_partners = result['partners'];

                this.available_formats = result['formats'];
                this.selected_formats = result['formats'];

                this.available_audiences = result['audiences'];
                this.selected_audiences = result['audiences'];

                this.available_regions = result['regions'];
                this.selected_regions = result['regions'];
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }

            this.saved_report_loading = false;
            this.loading_new_filters = false;
        },
        create_report_folder: async function(payload) {
            let create_payload = {
                project_id: this.$project.get_val(),
                parent_id: payload.parent_id,
                folder_name: payload.folder_name
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller.create_report_folder(token, create_payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            if (result) {
            await this.get_ort_reports();
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
        },
        create_report_selected: function(parent_id) {
            this.curr_folder_id = parent_id;
            this.dialogCreate = true;
        },
        report_published: async function(success) {
            this.dialogCreate = false;
            this.curr_folder_id = null;
            if (success) {
            await this.get_ort_reports();
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
        },
        publish_ort_report: async function () {
            let lvls = [...this.selected_pivot_variables]
            lvls.unshift("Audiences")
            let payload = {
                project_id: this.$project.get_val(),
                report_name: this.new_report_name,
                report_start_date: this.report_start_date,
                report_end_date: this.report_end_date,
                queue_payload: this.message_queue_payload,

                data_lvls: lvls,

                audiences: this.selected_audiences,
                campaigns: this.selected_campaigns,
                channels: this.selected_channels,
                partners: this.selected_partners,
                formats: this.selected_formats,
                regions: this.selected_regions
            };

            let token = await this.$auth.getTokenSilently();
            await ort_reporting_api_caller.publish_report(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            
            await this.get_ort_reports();
            this.dialogCreate = false;
            this.new_report_name = "";
            this.selected_pivot_variables = this.available_pivot_variables;
        },
        delete_report_on_click: function(report_id, report_name){
            this.deleteReportPayload = {
                report_id: report_id,
                report_name: report_name,
            }
            this.deleteConfirm = true;
        },
        move_reports: async function(payload) {
            const reportIds = (payload.entity_ids || []).map((id) => Number(id));

            if (reportIds.length === 0 || payload.parent_id === null || payload.parent_id === undefined) {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
                return;
            }

            this.saved_report_loading = true;
            const movePayload = {
                project_id: this.$project.get_val(),
                report_ids: reportIds,
                parent_id: payload.parent_id,
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller
                .move_reports(token, movePayload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });

            if (result) {
                await this.get_ort_reports();
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
                this.saved_report_loading = false;
            }
        },
        delete_ort_report: async function(report_id){
            this.page_loading = true;
            this.deleteConfirm = false;
            let payload = {
                client_id: this.$project.get_val().slice(0,4),
                report_id: report_id
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller
                .delete_report(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                    return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });

            if (!result || !result["report_id"]) {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
            await this.get_ort_reports();
            this.page_loading = false;
        },
        edit_name_on_click: function(report_id, report_name){
            this.editReportPayload = {
                report_id: report_id,
                report_name: report_name,
            }
            this.dialogEdit = true;
        },
         edit_name_confirm: async function(){
            await this.update_report();
            this.dialogEdit = false;
        },
        update_report: async function(payload) {
            let report_id = payload.id
            let report_name = payload.name

            if (report_id) {
                let update_payload = {
                    client_id: this.$project.get_val().slice(0,4),
                    report_id: report_id,
                    update_vals: {
                        report_name: report_name
                    }
                };

                let token = await this.$auth.getTokenSilently();
                let result = await ort_reporting_api_caller
                    .update_report(token, update_payload)
                    .then((resp) => {
                        if (resp["success"]) {
                        return resp["data"];
                        }
                        return false;
                    })
                    .catch(() => {
                        return false;
                    });

                if (!result || !result["report_id"]) {
                    this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
                } else {
                    this.$emit("triggerAlert", ALERT_TYPE_SUCCESS, ORT_REPORT_NAME_UPDATED);
                }
            }
            await this.get_ort_reports();
        },
        open_report: function(report_id) {
            if (this.directory_loading) {
                return;
            }

            this.$emit("open_report", report_id);
        },
    }
  };
  </script>
  
  <style scoped>
    .ort-saved {
        max-width: 100%;
        height: 100%;
    }

    .ort-saved__content {
        width: 100%;
        height: 100%;
    }

    .ort-saved__panel {
        height: 100%;
    }

    .ort-saved__loading-row {
        width: 100%;
        height: 100%;
    }

    .report_title {
        font-family: 'Poppins' !important;
        font-weight: 600 !important;
        font-size: 1.2em !important;
    }
    .no_saved{
        font-family: 'Poppins' !important;
        font-weight: 200 !important;
        font-size: 1.3em !important;
    }
    .dialogTitle {
      font-family: "Poppins";
      font-weight: 600 !important;
      font-size: 1.2em !important;
    }
    .actionText {
      font-family: "Poppins";
      font-weight: 400 !important;
      font-size: 0.9em !important;
    }
    .actionBtn {
      font-family: "Poppins";
      font-weight: 400 !important;
      font-size: 1em !important;
    }
    .filterSectionTitle {
      font-family: "Poppins";
      font-weight: 600 !important;
      font-size: 1.2em !important;
    }
  </style>
  
